import React from 'react';
import { Form } from 'react-bootstrap';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

function getOption(opt) {
  if (typeof opt === 'undefined' || opt === null) {
    return undefined;
  }
  if (typeof opt.label !== 'undefined' && typeof opt.value !== 'undefined') {
    return opt;
  }
  if (typeof opt.value !== 'undefined') {
    opt.label = opt.value; // eslint-disable-line no-param-reassign
    return opt;
  }
  return { label: opt, value: opt };
}

function SimpleSelect({ label, value, onChange, options, ...props }) {
  function handleChange(data) {
    if (Array.isArray(data)) {
      onChange(data.map(el => el.value));
    } else {
      onChange(data ? data.value : undefined);
    }
  }

  const SelectComponent = props.isCreateable ? CreatableSelect : Select;

  return (
    <Form.Group className="form-group">
      <Form.Label>{label}</Form.Label>
      <SelectComponent
        placeholder={props.placeholder || 'Select...'}
        value={Array.isArray(value) ? value.map(getOption) : getOption(value)}
        options={options.map(getOption)}
        onChange={handleChange}
        {...props}
      />
    </Form.Group>
  );
}

SimpleSelect.defaultProps = {
  isCreateable: false,
};

export default SimpleSelect;
